import React, { forwardRef, useState } from 'react';
import Proptypes from 'prop-types';
import MuiTooltip from '@material-ui/core/Tooltip';
import clsx from 'clsx';
import { makeStyles } from '../../lib/styles';
import arrowGenerator from './arrowGenerator';

const useStyle = makeStyles(theme => ({
  arrow: {
    position: 'absolute',
    fontSize: 6,
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
    },
  },
  popper: arrowGenerator(theme.palette.background.inverted),
  tooltip: {
    position: 'relative',
    backgroundColor: theme.palette.background.inverted,
    color: theme.palette.text.contrast,
    fontSize: theme.typography.fontSize,
    padding: '1em 1.5em',
  },
  tooltipPlacementLeft: {
    margin: '0 .5em',
  },
  tooltipPlacementRight: {
    margin: '0 .5em',
  },
  tooltipPlacementTop: {
    margin: '.5em 0',
  },
  tooltipPlacementBottom: {
    margin: '.5em 0',
  },
}));

const Tooltip = forwardRef(function Tooltip(props, ref) {
  const { children, className, content, showOnFocus, placement, ...restProps } = props;
  const { arrow, ...classes } = useStyle();
  const [arrowRef, setArrowRef] = useState(null);

  const title = (
    <>
      {content}
      <span className={arrow} ref={setArrowRef} />
    </>
  );

  return (
    <MuiTooltip
      classes={classes}
      className={clsx(className)}
      disableFocusListener={!showOnFocus}
      placement={placement}
      PopperProps={{
        popperOptions: {
          modifiers: {
            arrow: {
              enabled: Boolean(arrowRef),
              element: arrowRef,
            },
          },
        },
      }}
      {...restProps}
      title={title}
    >
      {React.cloneElement(children, { ref })}
    </MuiTooltip>
  );
});

Tooltip.propTypes = {
  children: Proptypes.element.isRequired,
  content: Proptypes.node.isRequired,
  showOnFocus: Proptypes.bool,
  className: Proptypes.string,
  placement: Proptypes.oneOf(['bottom', 'left', 'right', 'top']),
};

Tooltip.defaultProps = {
  showOnFocus: true,
  className: null,
  placement: 'bottom',
};

Tooltip.displayName = 'Tooltip';

export default Tooltip;
